import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { FormField } from 'ui/formField';

export const HttpHeaderTable = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.half};
`;

export const Row = styled.div`
  column-gap: ${spacing.plusHalf};
  display: flex;
  justify-content: start;
`;

export const ColumnField = styled(FormField)`
  &:not([data-idx='0']) label {
    display: none;
  }
  && {
    margin-top: 0;
  }
`;
